import React, { useEffect, useState } from "react";
import "./Checkout.css";
import { useNavigate } from "react-router-dom";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import Payment_Summary from "../cart/payment_summary/Payment_Summary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import OrderPlacedSuccessfullModal from "../common_components/common_modal/OrderPlacedSuccessfullModal/OrderPlacedSuccessfullModal";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../features/cart/cartSlice";
import {
  createOrder,
  getAllOrderAddress,
  getAllOrderAddressBilling,
  getBillingOrderAddress,
  getSingleOrderAddress,
  OrderCalculation,
  PaymentOnline,
} from "../../features/order/orderSlice";
import { Form } from "react-bootstrap";
import useRazorpay from "react-razorpay";
import { getNotifications } from "../../features/notifications/notificationSlice";
import { appSetup, OrderTimeSlot } from "../../features/master/masterSlice";
import dayjs from "dayjs";
import { convertTo12Hour, PaymentMethods } from "../../utils/common";

const Checkout = ({ setDeliveryNote, deliveryNote, ...props }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [Razorpay] = useRazorpay();

  // ---------------------------------------------------------------- state
  const [showModal, setShowModal] = useState(false);
  const [paymentValue, setPaymentValue] = useState(PaymentMethods.Online);
  const [paymentData, setPaymentData] = useState({});
  const [CouponData, setCouponData] = useState("");
  const [trackId, setTrackId] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [error, setErrors] = useState();
  const [addressId, setAddressId] = useState();
  const [GSTNumber, setGSTNumber] = useState("");
  const [loader, setLoader] = useState(false);

  // ------------------------------------------------------------ selectors
  const allAddress = useSelector((state) => state.order.allOrdersAddress);
  const allBillingAddress = useSelector(
    (state) => state.order.allBillingAddress,
  );
  const singleAddress = useSelector((state) => state.order.orderAddress);
  const billingOrderAddress = useSelector(
    (state) => state.order.billingOrderAddress,
  );
  const isSignin = useSelector((state) => state.auth.is_signin);
  const user = useSelector((state) => state?.user?.userInfo);
  const appstup = useSelector((state) => state.master.app_setup);
  const timeSlot = useSelector((state) => state.master.time_slot);

  // --------------------------------------------------------------- helpers
  const handleManualClose = () => {
    setShowModal(false);
  };

  const parts = [
    props?.orderAddress?.building,
    props?.orderAddress?.street,
    props?.orderAddress?.apartment,
    props?.orderAddress?.Users_Address_Detail?.Country?.name,
    props?.orderAddress?.Users_Address_Detail?.State?.name,
    props?.orderAddress?.Users_Address_Detail?.City?.name,
    props?.orderAddress?.Users_Address_Detail?.Pincode?.name,
  ];

  // Address actually used for the order (props win, then first saved address)
  const resolvedAddressId = props?.addressId || allAddress?.data?.[0]?.id;
  const resolvedBillingId =
    props?.addressBillingId || allBillingAddress?.data?.[0]?.id;

  // ------------------------------------------------------------- data load
  useEffect(() => {
    dispatch(getAllOrderAddress());
    dispatch(getAllOrderAddressBilling());
  }, [dispatch]);

  useEffect(() => {
    if (props?.addressId) {
      setAddressId(props.addressId);
    } else if (Array.isArray(allAddress?.data) && allAddress.data.length > 0) {
      setAddressId(allAddress.data[0].id);
    }
  }, [props?.addressId, allAddress]);

  useEffect(() => {
    if (resolvedAddressId) {
      dispatch(getSingleOrderAddress({ id: resolvedAddressId }));
    }
    if (resolvedBillingId) {
      dispatch(getBillingOrderAddress({ id: resolvedBillingId }));
    }
  }, [dispatch, resolvedAddressId, resolvedBillingId]);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  useEffect(() => {
    dispatch(OrderTimeSlot({ delivery_date: selectedDate }));
  }, [dispatch, selectedDate]);

  // ----------------------------------------------------- order calculation
  useEffect(() => {
    const calculate = async () => {
      const payload = { address_id: resolvedAddressId };
      if (CouponData) {
        payload.coupon_id = CouponData.id;
      }
      const res = await dispatch(OrderCalculation(payload));
      if (res.meta?.requestStatus === "fulfilled") {
        setPaymentData(res?.payload?.data);
      }
    };
    calculate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressId, CouponData, resolvedAddressId]);





  const PaymentOnlineCreate = async (razorpayResponse, data) => {
    const paymentId = razorpayResponse?.razorpay_payment_id;
    const productOrderId = data?.product_order_id;

    if (!paymentId || !productOrderId) {
      console.error("Razorpay confirmation data missing:", {
        paymentId,
        productOrderId,
      });
      setLoading(false);
      return;
    }

    setLoader(true);
    const res = await dispatch(
      PaymentOnline({
        id: productOrderId,
        payment_id: paymentId,
      }),
    );

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllCart(isSignin));
      dispatch(getNotifications());
      setLoading(false);
      setShowModal(true);
    } else {
      alert(res.payload?.message || "Payment was received but order confirmation failed. Please contact support.");
      setLoading(false);
    }
    setLoader(false);
  };

  // orderData is exactly what CreateOrder returns for online payments:
  // { key, order_id, amount (paise), currency, product_order_id, invoice_no }
  const openRazorpay = (orderData) => {
    const key = orderData?.key || process.env.REACT_APP_RAZORPAY_KEY;

    const missing = [];
    if (!Razorpay) missing.push("Razorpay SDK");
    if (!key) missing.push("Razorpay key");
    if (!orderData?.order_id) missing.push("order_id from the create-order API");
    if (!orderData?.product_order_id)
      missing.push("product_order_id from the create-order API");

    if (missing.length > 0) {
      setLoading(false);
      console.error("Razorpay checkout requirements missing:", missing);
      alert(`Payment could not be started. Missing: ${missing.join(", ")}.`);
      return;
    }

    const options = {
      key,
      amount: orderData.amount, // already in paise from the backend
      currency: orderData.currency || "INR",
      name: "Dport",
      description: "Live Transaction",
      order_id: orderData.order_id, // Razorpay order id (order_xxx)
      handler: (response) => PaymentOnlineCreate(response, orderData),
      modal: {
        ondismiss: () => setLoading(false), // user closed the popup
      },
      prefill: {
        name: user?.name,
        email: user?.email,
        contact: user?.conatct_no,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzp = new Razorpay(options);
    rzp.on("payment.failed", (response) => {
      console.error("Payment failed:", response?.error);
      setLoading(false);
      alert(response?.error?.description || "Payment failed. Please try again.");
    });
    rzp.open();
  };

  // ----------------------------------------------------------- place order
  const finalFunction = async () => {
    if (loading) return; // prevent double submit

    if (!selectedDate) {
      setErrors("Please select a date first!");
      return;
    }
    if (!selectedTime) {
      setErrors("Please select a Time first!");
      return;
    }

    setLoading(true);

    const datafinal = {
      address_id: resolvedAddressId,
      billing_address_id: resolvedBillingId,
      payment_method_id: paymentValue,
      order_summary: paymentData?.order_summary,
      order_Details_summary: paymentData?.order_Details_summary,
      delivery_note: deliveryNote,
      delivery_date: selectedDate,
      time_slot_id: selectedTime,
      gst_number: GSTNumber,
    };

    if (CouponData) {
      datafinal.coupon_id = CouponData.id;
    }

    try {
      const res = await dispatch(createOrder(datafinal));

      if (res.meta?.requestStatus === "fulfilled") {
        const orderData = res?.payload?.data;

        if (Number(paymentValue) === Number(PaymentMethods.Online)) {
          // Loading stays true until Razorpay succeeds, fails or is dismissed
          setTrackId({ id: orderData?.product_order_id });
          openRazorpay(orderData);
        } else {
          setTrackId(orderData);
          await dispatch(getAllCart(isSignin));
          dispatch(getNotifications());
          setLoading(false);
          setShowModal(true);
        }
      } else {
        setLoading(false);
        if (res.payload?.payment_method_id) {
          alert("Please Select Payment Option!");
        } else {
          alert(
            res.payload?.message ||
            "Could not place the order. Please try again.",
          );
        }
      }
    } catch (err) {
      console.error("Place order failed:", err);
      setLoading(false);
      alert("Something went wrong while placing the order.");
    }
  };

  // ------------------------------------------------------- delivery dates
  const today = dayjs();
  const currentHour = dayjs().hour();
  const startDate =
    currentHour >= appstup?.order_time ? today.add(1, "day") : today;

  const dates = Array.from({ length: appstup?.delivery_range || 7 }, (_, i) => {
    const d = startDate.add(i, "day");
    return {
      day: d.format("ddd"),
      date: d.format("DD/MM"),
      fullDate: d.format("YYYY-MM-DD"),
    };
  });

  // ---------------------------------------------------------------- render
  return (
    <section className="Cart Checkout">
      <Breadcrumb_comp
        breadcrumbs={[
          { label: "Home", link: "/", isActive: false },
          { label: "Cart", link: "/cart", isActive: false },
          { label: "CHECKOUT", link: "", isActive: true },
        ]}
        additionalClass="groceries "
      />

      <div className="container ">
        <div className="cart_main_container">
          <div className="data_holder">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                <div className="left_side_card">
                  <div className="gray_box_holder">
                    <div className="common_white_card">
                      <div className="img_holder">
                        <img
                          src="/assets/images/checkout/location.png"
                          className="left_img"
                          alt=""
                        />
                      </div>

                      <div className="address_holder">
                        <b>Shipping Address </b>
                        <p className="type_text">
                          <FontAwesomeIcon
                            icon={faBuilding}
                            className="inner_icon"
                          />
                          {singleAddress?.apartment},{singleAddress?.floor},
                          {singleAddress?.building},{singleAddress?.direction},
                          {singleAddress?.street},
                          {singleAddress?.city_id?.label},
                          {singleAddress?.state_id?.label},
                          {singleAddress?.country_id?.label},
                          {singleAddress?.pincode_id?.label}
                        </p>
                      </div>
                    </div>

                    <div className="common_white_card">
                      <div className="img_holder">
                        <img
                          src="/assets/images/checkout/location.png"
                          className="left_img"
                          alt=""
                        />
                      </div>

                      <div className="address_holder">
                        <b>Billing Address </b>
                        <p className="type_text">
                          <FontAwesomeIcon
                            icon={faBuilding}
                            className="inner_icon"
                          />
                          {billingOrderAddress?.apartment},
                          {billingOrderAddress?.floor},
                          {billingOrderAddress?.building},
                          {billingOrderAddress?.direction},
                          {billingOrderAddress?.street},
                          {billingOrderAddress?.city_id?.label},
                          {billingOrderAddress?.state_id?.label},
                          {billingOrderAddress?.country_id?.label},
                          {billingOrderAddress?.pincode_id?.label}
                        </p>
                      </div>
                    </div>

                    <div className="common_white_card ">
                      <Form.Check
                        type="radio"
                        label="Cash on Delivery"
                        name="paymentOption"
                        value="cash"
                        onChange={() => setPaymentValue(1)}
                        checked={paymentValue === 1}
                      />
                    </div>
                    <div className="common_white_card ">
                      <Form.Check
                        type="radio"
                        label="Online"
                        name="paymentOption"
                        value="razorpay"
                        onChange={() => setPaymentValue(PaymentMethods.Online)}
                        checked={paymentValue === PaymentMethods.Online}
                      />
                    </div>

                    <div className="time_slot_holder">
                      {error && (
                        <p style={{ color: "red", marginTop: "8px" }}>
                          {error}
                        </p>
                      )}
                      <h3>Select Delivery Date</h3>
                      <div className="date_selector">
                        {dates.map((item) => (
                          <div
                            key={item.fullDate}
                            className="date_box"
                            onClick={() => {
                              setSelectedDate(item.fullDate);
                              setSelectedTime(null); // slots depend on the date
                              setErrors("");
                            }}
                          >
                            <span
                              className={`day ${selectedDate === item.fullDate ? "active" : ""
                                }`}
                            >
                              {item.day}
                            </span>
                            <span className="date">{item.date}</span>
                          </div>
                        ))}
                      </div>

                      <h3>Select Time Slot</h3>
                      <div className="time_slot_list">
                        {(timeSlot || []).map((slot) => (
                          <div
                            key={slot?.id}
                            className={`time_slot_box ${selectedTime === slot?.id ? "active" : ""
                              }`}
                            onClick={() => {
                              setSelectedTime(slot?.id);
                              setErrors("");
                            }}
                          >
                            <span>{convertTo12Hour(slot.from)}</span>
                            <span className="to_text">To</span>
                            <span>{convertTo12Hour(slot.to)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <Payment_Summary
                  loading={loading}
                  setLoading={setLoading}
                  GSTNumber={GSTNumber}
                  setGSTNumber={setGSTNumber}
                  isCheckoutPage
                  checkout_btn="Place Order"
                  checkoutAction={finalFunction}
                  paymentValue={paymentValue}
                  setPaymentValue={setPaymentValue}
                  addressId={props?.addressId}
                  data={paymentData?.order_summary}
                  parts={parts}
                  disable={true}
                  CouponData={CouponData}
                  setCouponData={setCouponData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <OrderPlacedSuccessfullModal
        handleManualClose={handleManualClose}
        show={showModal}
        onHide={() => setShowModal(false)}
        baseLink={`/order-details/${trackId?.id}`}
      />
    </section>
  );
};

export default Checkout;
